/**
 * Configuración de assets - 37° Simposio
 * URL base: https://ftp.pcnpublicidad.com/heel/
 * Archivos disponibles en el servidor FTP
 */
export const ASSETS_BASE_URL = 'https://ftp.pcnpublicidad.com/heel/';

export const ASSET_FILES = {
  fondo: 'Fondo_KV.png',
  logoSimposio: 'Logo_37-simposio-brsm.png',
  logoHeel: 'Logo_Heel.png',
  logoMedicina: 'Logo_Medicina_BiorreguladoraSistemas.png',
  mujerKv: 'Mujer_Kv_Final.png',
};

export const getAssetUrl = (key) => {
  const file = ASSET_FILES[key];
  return file ? `${ASSETS_BASE_URL}${encodeURIComponent(file)}` : null;
};

/**
 * Configuración por defecto del diseño 37° Simposio
 * Se usa cuando la API no devuelve configuración o cuando faltan campos
 */
export const DEFAULT_DESIGN_CONFIG = {
  bodyBackgroundImage: getAssetUrl('fondo'),
  headerImage: getAssetUrl('logoSimposio'),
  logoUrl: getAssetUrl('logoSimposio'),
  headerText: '37° Simposio',
  tabTitle: '37° Simposio - Medicina Biorreguladora',
  tabDescription: 'Explora el evento y participa en las actividades',
  buttonText: 'Iniciar sesión',
  fontColor: '#1f2937',
  fontColorSecondary: '#6b7280',
  primaryColor: '#0d9488',
  buttonColor: '#0d9488',
  buttonTextColor: '#ffffff',
  mujerKvUrl: getAssetUrl('mujerKv'),
  additionalLogos: [
    { url: getAssetUrl('logoHeel'), x: 5, y: 5, width: 80, height: 40 },
    { url: getAssetUrl('logoMedicina'), x: 85, y: 5, width: 80, height: 40 },
  ],
  welcomeLogos: [
    { url: getAssetUrl('logoMedicina'), position: 'bottom-left' },
    { url: getAssetUrl('logoHeel'), position: 'bottom-right' },
  ],
};
